'use strict';

/**
 * @name storage
 */

exports.getItem = require('./get-item.js');
exports.setItem = require('./set-item.js');
exports.removeItem = require('./remove-item.js');
exports.setResult = require('./set-result.js');



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/storage/index.js
// module id = 238
// module chunks = 10 11 12 13 14 15 16 17 18 19